import React, { useRef, useState } from 'react';
import axios from '../../../api/management_api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { CSVLink } from "react-csv";
import { vendors } from '../../../data/constant';
import ErrorBody from '../../common/error/ErrorBody';
import AiTable from './AiTable';
import NamAddressSearch from './NamAddressSearch';

export default function AccessInventory() {
    const [formData, setFormData] = useState({
        namId: "",
        installationId: "",
        vendorAddressId: "",
        externalInstallationId: "",
        installationCode: "",
        infrastructureOwner: "",
        vendorId: "",
        pageId: 0,
        pageSize: "1000"
    });

    const [error, setError] = useState();
    const [info, setInfo] = useState([]);
    const [load, setLoad] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showMad, setShowMad] = useState(true);
    const [namResetKey, setNamResetKey] = useState(0);
    const madLookupRef = useRef(0);
    const [madDetails, setMadDetails] = useState({
        houseNumber: "",
        houseLetter: "",
        side: "",
        floor: "",
        streetName: "",
        postCode: ""
    });

    const searchHistory = (e, pageNo) => {
        e.preventDefault();
        setError();
        setShowMad(false);
        setLoad(true);
        setInfo([]);
        setFormData(pre => ({ ...pre, pageId: pageNo }));
        axios.post(`/v2/accessinventory/getAccessInventory`, {
            ...formData,
            pageId: pageNo
        }).then(res => {
            setLoad(false);
            if (res.data.length > 0) {
                setInfo(res.data);
            } else {
                setError("No Data Found");
            }

        }).catch(err => {
            setLoad(false);
            setError(err.message);
        });

    }

    const resetHistory = () => {
        madLookupRef.current += 1;
        setLoading(false);
        setNamResetKey(key => key + 1);
        setFormData({
            namId: "",
            installationId: "",
            vendorAddressId: "",
            externalInstallationId: "",
            installationCode: "",
            infrastructureOwner: "",
            vendorId: "",
            pageId: 0,
            pageSize: "1000"
        });
        resetMad();
    }

    const handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData(pre => ({ ...pre, [name]: value }));
    }

    const resetMad = () => {
        setMadDetails({
            houseNumber: "",
            houseLetter: "",
            side: "",
            floor: "",
            streetName: "",
            postCode: ""
        });
    }

    const handleMad = (e) => {
        let name = e.target.name;
        let value = e.target.value.trim();
        setNamResetKey(key => key + 1);
        setNamId('');
        setMadDetails(pre => ({ ...pre, [name]: value }));
    }

    const findNam = () => {
        const requestId = ++madLookupRef.current;
        setNamResetKey(key => key + 1);
        setError();
        setLoading(true);
        axios.post("/v1/masterAddressCache/getNamIDbyAddress", madDetails)
            .then(res => {
                if (requestId !== madLookupRef.current) return;
                if (!res.data.addressSpecificId) {
                    throw new Error('No NAM ID found for this address.');
                }
                setFormData(previous => ({ ...previous, namId: res.data.addressSpecificId }));
                setLoading(false);
            }).catch(error => {
                if (requestId !== madLookupRef.current) return;
                setFormData(previous => ({ ...previous, namId: '' }));
                setError(error.message);
                setLoading(false);
            });
    }

    const setNamId = namId => {
        madLookupRef.current += 1;
        setLoading(false);
        setFormData(previous => ({ ...previous, namId: namId, pageId: 0 }));
    };

    const selectNamAddress = address => {
        const building = String(address.buildingNoWithSuffix || '').split(',')[0].trim();
        const parts = building.match(/^(\d+)\s*(.*)$/);

        // Populate the NAM ID directly from the autocomplete response.
        setNamId(address.id != null ? String(address.id) : '');
        setError();
        setShowMad(true);
        setMadDetails({
            streetName: address.streetName || '',
            houseNumber: parts ? parts[1] : building,
            houseLetter: parts ? parts[2] : '',
            floor: String(address.floorId ?? address.floor ?? ''),
            side: String(address.suiteId ?? address.suite ?? address.door ?? ''),
            postCode: String(address.postalCode ?? '')
        });
    };

    return (
        <div>
            <div className="card">
                <h5 className="card-header">Access Inventory Search</h5>
                <div className="px-3 pt-3">
                    <NamAddressSearch key={namResetKey}
                        onSelect={selectNamAddress}
                        onClear={() => setNamId('')}/>
                </div>
                <div className="div-table my-2">
                    <div className="form-row">
                        <div className="form-group col">
                            <label htmlFor="inventory-nam-id">NAM ID</label>
                            <div className="input-group">
                                <input id="inventory-nam-id" type="text" className="form-control form-control-sm" name="namId"
                                    value={formData.namId} onChange={event => {
                                        setNamResetKey(key => key + 1);
                                        setNamId(event.target.value);
                                    }} />
                                <div className="input-group-append" title={showMad ? "" : "find nam id by address"}>
                                    <button className="btn btn-sm btn-secondary" type="button"
                                        onClick={() => setShowMad(pre => !pre)}>
                                        {showMad ? "Hide" : "Find"}</button>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col">
                            <label htmlFor="installationId">Installation Id</label>
                            <input type="text" className="form-control form-control-sm" name="installationId"
                                value={formData.installationId}
                                onChange={handleChange} />
                        </div>

                        <div className="form-group col">
                            <label htmlFor="response">Vendor</label>
                            <select className="form-control form-control-sm" name="vendorId"
                                value={formData.vendorId} onChange={handleChange}>
                                <option value="">All</option>
                                {vendors.map((v, index) => <option key={index} value={v.value}>{v.name}</option>)}
                            </select>
                        </div>
                        <div className="form-group col">
                            <label htmlFor="vendorAddressId">Vendor Address Id</label>
                            <input type="text" className="form-control form-control-sm" name="vendorAddressId"
                                value={formData.vendorAddressId}
                                onChange={handleChange} />
                        </div>
                        <div className="form-group col">
                            <label htmlFor="externalInstallationId">External Installation Id</label>
                            <input type="text" className="form-control form-control-sm" name="externalInstallationId"
                                value={formData.externalInstallationId}
                                onChange={handleChange} />
                        </div>
                        {showMad && <div className="div-table col-md-12 mx-auto" style={{ background: "#f0f1f375" }}>
                            <div className="form-row">
                                <div className="form-group col-md-2">
                                    <label htmlFor="inventory-street-name">Street Name</label>
                                    <input id="inventory-street-name" type="text" className="form-control form-control-sm" name="streetName"
                                        value={madDetails.streetName} onChange={handleMad} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inventory-house-number">House no</label>
                                    <input id="inventory-house-number" type="text" className="form-control form-control-sm" name="houseNumber"
                                        value={madDetails.houseNumber} onChange={handleMad} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inventory-house-letter">House letter</label>
                                    <input id="inventory-house-letter" type="text" className="form-control form-control-sm" name="houseLetter"
                                        value={madDetails.houseLetter} onChange={handleMad} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inventory-floor">Floor</label>
                                    <input id="inventory-floor" type="text" className="form-control form-control-sm" name="floor"
                                        value={madDetails.floor} onChange={handleMad} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inventory-side">Side</label>
                                    <input id="inventory-side" type="text" className="form-control form-control-sm" name="side"
                                        value={madDetails.side} onChange={handleMad} />
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inventory-postcode">Post Code</label>
                                    <input id="inventory-postcode" type="text" className="form-control form-control-sm" name="postCode"
                                        value={madDetails.postCode} onChange={handleMad} />
                                </div>

                            </div>
                            <div className="form-row">
                                <div className="col-sm" style={{ textAlign: "center" }}>
                                    <button type="submit" className="btn btn-secondary ml-2"
                                        onClick={() => findNam()} disabled={loading}>{loading ? "Wait" : "Get NamId"}</button>
                                </div>
                            </div>
                        </div>}
                        <div className="col-md-12">
                            <div className="row">
                                <div className="form-group col-md-2">
                                    <label htmlFor="response">Records</label>
                                    <select className="form-control form-control-sm" name="pageSize"
                                        value={formData.pageSize}
                                        onChange={handleChange}>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="200">200</option>
                                        <option value="500">500</option>
                                        <option value="1000">1000</option>
                                    </select>
                                </div>
                                <div className="form-group col-md-8 my-auto text-center">
                                    <button type="submit" id="search-btn" className="btn btn-info"
                                        onClick={(e) => searchHistory(e, 0)}>Search</button>
                                    <button id="search-btn" className="btn btn-danger ml-2"
                                        onClick={() => resetHistory()}>Reset</button>
                                    {process.env.REACT_APP_ENVIRONMENT == "prod"
                                    ? ""
                                    :<CSVLink className="btn btn-info ml-2" filename="access-inventory-search.csv" data={info}>
                                         Export to CSV
                                     </CSVLink>
                                    }
                                </div>
                                <div className="form-group col-md-2 my-auto text-right">
                                    <button id="search-btn" className="btn btn-info "
                                        disabled={formData.pageId <= 0}
                                        onClick={(e) => searchHistory(e, formData.pageId - 1)}
                                    >&lt;</button>
                                    <i>Page: {formData.pageId} </i>
                                    <button id="search-btn" className="btn btn-info ml-2"
                                        disabled={info.length < formData.pageSize}
                                        onClick={(e) => searchHistory(e, formData.pageId + 1)}
                                    >&gt;</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="div-table mb-3">
                    {error ? <ErrorBody errorMessage={error} /> :
                        info.length > 0 ? <AiTable rowData={info} /> :
                            <div className="text-center p-4 text-wrap">
                                <FontAwesomeIcon className="mb-3" icon={faSearch} size="5x" color="var(--tdc-blue)"
                                    spin={load ? true : false} />
                                <h2 style={{ color: "var(--tdc-dark)" }}>
                                    {load ? "Loading" : "Access Inventory"}</h2>
                            </div>}
                </div>
            </div>

        </div>
    )
}
